var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.formatElapsed))]),_vm._v(" / "),_c('span',[_vm._v(_vm._s(_vm.formatDuration))])])
}
var staticRenderFns = []

export { render, staticRenderFns }